"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceVariables = replaceVariables;
exports.createBindings = createBindings;
exports.termToString = void 0;

var _ldflex = require("ldflex");

var termToString = _ldflex.SparqlHandler.prototype.termToString;
exports.termToString = termToString;

function replaceVariables(template, terms) {
  for (var name in terms) {
    template = template.replace(new RegExp("_:".concat(name), 'g'), termToString(terms[name]));
  }

  return template;
} // Imitate Comunica's response for bindings as a Immutable.js object.


function createBindings() {
  for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  return {
    size: items.length,
    values: function values() {
      return {
        next: function next() {
          return {
            value: items.shift()
          };
        }
      };
    }
  };
}